const object = value => value && typeof value === 'object' && !Array.isArray(value);
const clone = value => value === undefined ? undefined : JSON.parse(JSON.stringify(value));
export function sameValue(a, b) {
  if (a === b) return true;
  if (Array.isArray(a) && Array.isArray(b)) return a.length === b.length && a.every((v, i) => sameValue(v, b[i]));
  if (object(a) && object(b)) {
    const keys = Object.keys(a);
    return keys.length === Object.keys(b).length && keys.every(key => Object.hasOwn(b, key) && sameValue(a[key], b[key]));
  }
  return false;
}

// The form is a projection, not the definition. Apply only differences between
// the initially displayed values and the current controls to the original data.
export function mergeEdited(original, before, after) {
  if (sameValue(before, after)) return clone(original);
  if (Array.isArray(before) && Array.isArray(after) && after.every(item => object(item) && typeof item.label === 'string')) {
    return after.map((item, index) => {
      const matches = before.filter(prior => prior?.label === item.label);
      const prior = matches.length === 1 ? matches[0] : before.length === after.length ? before[index] : null;
      const saved = prior && Array.isArray(original) ? original.find(value => value?.label === prior.label) : null;
      return prior ? mergeEdited(saved || prior, prior, item) : clone(item);
    });
  }
  if (!object(before) || !object(after)) return clone(after);
  const result = object(original) ? clone(original) : {};
  for (const key of new Set([...Object.keys(before), ...Object.keys(after)])) {
    if (sameValue(before[key], after[key]) && Object.hasOwn(before, key) === Object.hasOwn(after, key)) continue;
    if (!Object.hasOwn(after, key)) delete result[key];
    else result[key] = mergeEdited(original?.[key], before[key], after[key]);
  }
  return result;
}

function mergeActions(original, before, after) {
  const merged = after.map(action => {
    const prior = before.find(item => item.type === action.type);
    const saved = (original || []).find(item => item.type === action.type);
    return prior ? mergeEdited(saved || prior, prior, action) : clone(action);
  });
  // The controls have a fixed display order; changing one checkbox does not
  // authorize reordering the customer's existing CTA bar.
  const order = [...(original || []).map(action => action.type), ...after.map(action => action.type)];
  return merged.sort((a, b) => order.indexOf(a.type) - order.indexOf(b.type));
}

export function appearanceChanges(saved, before, after) {
  const changes = {};
  for (const [key, value] of Object.entries(after)) {
    if (sameValue(before[key], value)) continue;
    changes[key] = ['legal_notice', 'consent'].includes(key) ? clone(value) : key === 'actions'
      ? mergeActions(saved?.actions, before.actions || [], value)
      : mergeEdited(saved?.[key], before[key], value);
  }
  return changes;
}
